import { render, staticRenderFns } from "./BullentinView.vue?vue&type=template&id=72f9b568&scoped=true"
import script from "./BullentinView.vue?vue&type=script&lang=js"
export * from "./BullentinView.vue?vue&type=script&lang=js"
import style0 from "./BullentinView.vue?vue&type=style&index=0&id=72f9b568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f9b568",
  null
  
)

export default component.exports